/**
 * Created by choizhang on 2018/3/1.
 */

import localeCN from './zh-cn';
import localeHK from './zh-hk';
import localeEN from './en';

export default {
    en: localeEN,
    sc: localeCN,
    tc: localeHK,
}



// WEBPACK FOOTER //
// ./src/locale/index.js